import { explore } from "../../../../service/API";
import store from "../../../store/store";

// TOOLS
const pathInfo = require("path");

export class Pdf {
  constructor() {
    this.name = "Pdf";
    this.pdfSource = "";
    this.realSource = "";
  }

  pdf(pdfPath) {
    // WE SHOW LOAD BAR
    store.dispatch("loadStarted");

    return new Promise((resolve, reject) => {
      const dir = pathInfo.basename(pdfPath, ".pdf");

      explore
        .post("/io/pdftoimg/", {
          currPath: pdfPath,
          sid: store.state.user.socId,
        })
        .then((response) => {
          const data = {
            dirname: dir,
            files: response.data,
          };

          store.dispatch("pdfCreated", data);
          resolve(data);
        })
        .catch((err) => {
          console.error(err);
          reject({
            dirname: dir,
            files: [],
          });
        })
        .finally(() => {
          // WE HIDE LOAD BAR
          store.dispatch("loadFinished");
        });
    });
  }
}
